<template>
   <vue-final-modal 
      v-model="addOutModal" 
      :focus-trap="true" 
      @click-outside="$emit('cancel')"
      classes="modal-container"
      content-class="modal-content"
      >
      <div id="qaz" class="border text-center">
         <button>0</button>
         <br>
         <button>1</button>
         <br>
         <button @click="$emit('cancel')">2</button>
         <br>
         <button>3</button>
         <br>
         <button @click="addInModal= true">4</button>
      </div>
   </vue-final-modal>
   <vue-final-modal v-model="addInModal" :focus-trap="true" attach="#qaz" class="text-end">
      <button>1</button>
      <br>
      <button @click="$emit('cancel')">2</button>
      <br>
      <button>3</button>
   </vue-final-modal>
</template>

<script>
import { ref } from 'vue';
import { VueFinalModal } from 'vue-final-modal'

export default {
   components: {
      VueFinalModal
   },
   emits: [ 'cancel', 'addInModal' ],
   setup() {

      const addInModal = ref(false)
      const addOutModal = ref(true)
      return {
         addInModal, addOutModal
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style>
::v-deep(.modal-content) {
  /*
  background: #fff;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
</style>